import { configureStore } from "@reduxjs/toolkit";

import loginReducer from "./modules/login/slices/login.slice";
import registrationReducer from "./modules/registration/slices/register.slice";
import settingsReducer from "./modules/settings/slices/settings.slice";
import passwordReducer from "./modules/password/slices/password.slice";
import smsloginReducer from "./modules/smslogin/slices/smslogin.slice";
import twofactorReducer from "./modules/twofactor/slices/twofactor.slice";
import vippsReducer from "./modules/vipps/slices/vipps.slice";

export const store = configureStore({
	reducer: {
		registration: registrationReducer,
		smslogin: smsloginReducer,
		settings: settingsReducer,
		vippslogin: vippsReducer,
		login: loginReducer,
		password: passwordReducer,
		twofactor: twofactorReducer,
	},
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
